import { kebabCase } from 'lodash'

export const getNavigationId = (label: string, prefix?: string) =>
	kebabCase(`${prefix ? `${prefix}-` : ''}${label.toLowerCase()}`)
